import PropTypes from 'prop-types';

import { Group, Text, Accordion, Box } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

import { breakpoints } from 'styles/theme.variables';

import styles from './ToggleCard.module.scss';

export default function ToggleCard({
  allowFullWidth,
  badge,
  children,
  subtitle,
  title,
  dataTestId = 'expand',
}) {
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.md})`, true, {
    getInitialValueInEffect: false,
  });

  const defaultValue = isMobile && title !== 'Order' ? null : title;
  return (
    <Accordion
      defaultValue={defaultValue}
      variant="card-info"
      classNames={{
        content: allowFullWidth && styles.fullWidth,
      }}
      data-testid={dataTestId}
    >
      <Accordion.Item value={title}>
        <Accordion.Control padding="md">
          {badge && <Box mb="xs">{badge}</Box>}
          <Group justify="space-between" wrap="nowrap" align="top">
            <Text variant="caption-md">{title}</Text>
          </Group>
          {subtitle && (
            <Text variant="sublabel-sm" pt="xs2">
              {subtitle}
            </Text>
          )}
        </Accordion.Control>
        <Accordion.Panel>{children}</Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
}

ToggleCard.propTypes = {
  allowFullWidth: PropTypes.bool,
  badge: PropTypes.node,
  children: PropTypes.node,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  dataTestId: PropTypes.string,
};
